<template>
  <v-dialog v-model="openDialog"
            max-width="400" lazy>
    <v-card>
      <v-card-title class="title">
        Update {{type}} ETA
      </v-card-title>
      <v-layout column class="px-3">
        <v-layout>
          <date-picker
            input-id="ETAPicker"
            placeholder="New ETA"
            v-model="etaUpdateTo">
          </date-picker>
        </v-layout>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn v-if="type === 'pickup'"
               color="accent"
               :loading="loadingBtn"
               @click="updatePickupETA">
          Update Pickup ETA
        </v-btn>
        <v-btn color="accent" @click="updateDeliveryETA"
               :loading="loadingBtn"
               v-else-if="type === 'delivery'">
          Update Delivery ETA
        </v-btn>
        <v-btn flat color="accent" @click="openDialog = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import API from '@/api/index';
import DatePicker from '@/components/DatePicker';

import * as Timestamps from '@/types/timestamp';

export default {
  name: 'UpdateEtaDialog',
  props: {
    value: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    loadId: {
      type: String,
    },
  },
  data() {
    return {
      loadingBtn: false,
      etaUpdateTo: null,
      openDialog: this.value,
    };
  },
  components: {
    DatePicker,
  },
  watch: {
    value() {
      this.openDialog = this.value;
      if (!this.value) {
        this.resetForm();
      }
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  methods: {
    resetForm() {
      this.etaUpdateTo = null;
    },
    async updatePickupETA() {
      try {
        this.loadingBtn = true;
        const myEta = Timestamps.localizedPickerTimestamp(this.etaUpdateTo);
        await API.load.updatePickupETA({ loadId: this.loadId, eta: myEta });
        this.$emit('refresh');
      } catch ({ message }) {
        this.$store.dispatch('applications/setErrorNotification', {
          message,
        });
      } finally {
        this.loadingBtn = false;
        this.openDialog = false;
      }
    },
    async updateDeliveryETA() {
      try {
        this.loadingBtn = true;
        const myEta = Timestamps.localizedPickerTimestamp(this.etaUpdateTo);
        await API.load.updateDeliveryETA({ loadId: this.loadId, eta: myEta });
        this.$emit('refresh');
      } catch ({ message }) {
        this.$store.dispatch('applications/setErrorNotification', {
          message,
        });
      } finally {
        this.loadingBtn = false;
        this.openDialog = false;
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/UpdateEtaDialog.vue